// @ts-nocheck
import getContentTypeConfig from './config'
import { parseHtmlPreRender, convertToInlineStyles } from './parseHtmlPreRender'
import {
    extractAllDocumentStyles,
    sanitizePageBuilderTree,
    normalizeEscapedJsonAttributes
} from './utils'

/**
 * Create a basic object representing a content type in our tree
 *
 * @param type
 * @param node
 * @returns {{appearance: any, children: Array, contentType: *}}
 */
const createContentTypeObject = (type, node) => {
    return {
        contentType: type,
        appearance: node ? node.getAttribute('data-appearance') : null,
        children: []
    }
}

/**
 * Walk over tree nodes extracting each content types configuration
 *
 * @param {Node} rootEl
 * @param {Object} contentTypeStructureObj
 * @returns {Object}
 */
const walk = (rootEl, contentTypeStructureObj) => {
    // console.log(contentTypeStructureObj);
    const tree = rootEl.ownerDocument.createTreeWalker(
        rootEl,
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
        null,
        false
    )

    let currentNode = tree.nextNode()
    while (currentNode) {
        if (currentNode.nodeType !== Node.ELEMENT_NODE) {
            currentNode = tree.nextNode()
            continue
        }

        const contentType = currentNode.getAttribute('data-content-type')

        if (!contentType) {
            currentNode = tree.nextNode()
            continue
        }

        const props = createContentTypeObject(contentType, currentNode)
        const contentTypeConfig = getContentTypeConfig(contentType)

        if (
            contentTypeConfig &&
            typeof contentTypeConfig.configAggregator === 'function'
        ) {
            try {
                Object.assign(
                    props,
                    contentTypeConfig.configAggregator(currentNode, props)
                )
            } catch (e) {
                console.error(
                    `Failed to aggregate config for content type ${contentType}.`,
                    e
                )
            }
        } else {
            console.warn(
                `Page Builder ${contentType} content type is not supported, this content will not be rendered.`
            )
        }

        contentTypeStructureObj.children.push(props)
        walk(currentNode, props)
        currentNode = tree.nextSibling()
    }

    return contentTypeStructureObj
}

const bodyId = 'html-body'

/**
 * Parse the master format storage HTML
 *
 * @param {String} htmlStr
 * @returns {Object}
 */
const parseStorageHtml = (htmlStr) => {
    const sanitizedHtmlStr = normalizeEscapedJsonAttributes(htmlStr)
    if (typeof window === 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
        const jsdom = require('jsdom')
        return parseHtmlPreRender(jsdom, sanitizedHtmlStr)
    }
    const container = new DOMParser().parseFromString(
        sanitizedHtmlStr,
        'text/html'
    )
    const stageContentType = createContentTypeObject('root-container')
    container.body.id = bodyId
    const domWindow = container.defaultView ?? window
    convertToInlineStyles(container, { window: domWindow })
    const cssBlocks = extractAllDocumentStyles(container.body)
    const tree = walk(container.body, stageContentType)
    tree.cssBlocks = cssBlocks
    return sanitizePageBuilderTree(tree)
}

export default parseStorageHtml
